import { render, staticRenderFns } from "./IntermediateHeader.vue?vue&type=template&id=6fc48c84&scoped=true&"
var script = {}
import style0 from "./IntermediateHeader.vue?vue&type=style&index=0&id=6fc48c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc48c84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc48c84')) {
      api.createRecord('6fc48c84', component.options)
    } else {
      api.reload('6fc48c84', component.options)
    }
    module.hot.accept("./IntermediateHeader.vue?vue&type=template&id=6fc48c84&scoped=true&", function () {
      api.rerender('6fc48c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/IntermediateHeader.vue"
export default component.exports